var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MglMap',{attrs:{"zoom":6,"center":_vm.center,"accessToken":_vm.accessToken,"mapStyle":_vm.mapStyle},on:{"load":_vm.loaded}})}
var staticRenderFns = []

export { render, staticRenderFns }